import createElement from '../logical-components/createElement';
// Global helpers
import svgs from './svgs';
import renderText from '../logical-components/renderText';
import internalEvents from '../logical-components/internalEvents';
var template = function (arg) {
    return "<img src='".concat(arg.fullImageUri, "' alt='").concat(arg.title, " - ").concat(arg.placementDate, "' />");
};
var AdvertisementCard = function (config, section, image, advertisementsWrapper, featured, handleClick) {
    var _a;
    var events = internalEvents(config);
    var card = createElement('div', [
        {
            type: 'class',
            value: "_mnslq-rm-adw ".concat(featured ? '_mnslq-mg-img' : ''),
        },
    ]);
    if ((_a = section === null || section === void 0 ? void 0 : section.views) === null || _a === void 0 ? void 0 : _a.advertisementCard) {
        var ele = section.views.advertisementCard({
            config: config,
            section: section,
            svgs: svgs,
            data: image,
            renderText: renderText,
            events: events,
            wrapper: advertisementsWrapper,
            featured: featured,
            handleClick: handleClick,
        });
        if (typeof ele === 'string') {
            card.innerHTML = ele;
        }
        else {
            card.appendChild(ele);
        }
    }
    else {
        card.innerHTML = template({
            fullImageUri: image,
            title: '',
            placementDate: ''
        });
    }
    if (handleClick) {
        card.addEventListener('click', function () {
            handleClick(image);
        });
    }
    return card;
};
var rememberMeAdvertisements = function (config, section, advertisements) {
    var _a;
    var advertisementsWrapper = createElement('div', [
        { type: 'class', value: '_msnlq-ad-wrapper' },
    ]);
    var advertisementList = (advertisements === null || advertisements === void 0 ? void 0 : advertisements.advertisements) || advertisements;
    var adsToUse = advertisementList;
    var images = advertisementList.reduce(function (acc, advertisement) {
        advertisement.fullImageUri.forEach(function (media) {
            acc.push(media.url);
        });
        return acc;
    }, []);
    if (((_a = config === null || config === void 0 ? void 0 : config.options) === null || _a === void 0 ? void 0 : _a.hideAdvertisements) || !adsToUse) {
        return advertisementsWrapper;
    }
    var showOverlay = false;
    var imageIndex = 0;
    advertisementsWrapper.innerHTML = "\n        <h3> ".concat(renderText('rememberMe.navigation.advertisements'), " </h3>\n        <div class='_msnlq-ad-cnt-wr'></div>\n        \n        <div class='_msnlq-ad-overlay-wrap _msnlq-glr-hide'>\n            <div class='_msnlq-glr-img'>\n                <img src='").concat(images[0], "' alt='Mensenlinq' />\n            </div>\n            <div class='_msnlq-glr-close'> ").concat(svgs.close, " </div>\n            <div class='_msnlq-glr-leftarrow'> ").concat(svgs.arrow, "</div>\n            <div class='_msnlq-glr-rightarrow'> ").concat(svgs.arrow, " </div>\n        </div>\n    ");
    var toggle = function () {
        var overlay = advertisementsWrapper.querySelector('._msnlq-ad-overlay-wrap');
        if (showOverlay) {
            overlay.classList.remove('_msnlq-glr-hide');
        }
        else {
            overlay.classList.add('_msnlq-glr-hide');
        }
    };
    var changeImage = function (index) {
        advertisementsWrapper
            .querySelector('._msnlq-ad-overlay-wrap')
            .querySelector('img').src = images[index];
    };
    var openOverlay = function (index) {
        imageIndex = index;
        changeImage(imageIndex);
        showOverlay = !showOverlay;
        toggle();
    };
    var closeOverlay = function () {
        showOverlay = !showOverlay;
        toggle();
    };
    var nextImage = function () {
        imageIndex = imageIndex + 1;
        if (imageIndex > images.length - 1) {
            imageIndex = 0;
        }
        changeImage(imageIndex);
    };
    var prevImage = function () {
        imageIndex = imageIndex - 1;
        if (imageIndex === -1) {
            imageIndex = images.length - 1;
        }
        changeImage(imageIndex);
    };
    var contentWrapper = advertisementsWrapper.querySelector('._msnlq-ad-cnt-wr');
    if (images && images.length) {
        // add featured image
        contentWrapper.appendChild(AdvertisementCard(config, section, images[0], images, true, function (image) {
            openOverlay(imageIndex);
        }));
        // add other images
        if (images.length > 1) {
            images.forEach(function (image, index) {
                if (index >= 3) {
                    return;
                }
                contentWrapper.appendChild(AdvertisementCard(config, section, image, images, false, function (image) {
                    var _a;
                    var featuredImage = (_a = advertisementsWrapper
                        .querySelector('._mnslq-mg-img')) === null || _a === void 0 ? void 0 : _a.querySelector('img');
                    if (featuredImage) {
                        imageIndex = index;
                        featuredImage.src = "".concat(image);
                    }
                }));
            });
        }
    }
    advertisementsWrapper
        .querySelector('._msnlq-glr-close')
        .addEventListener('click', function () {
        closeOverlay();
    });
    advertisementsWrapper
        .querySelector('._msnlq-glr-leftarrow')
        .addEventListener('click', function () {
        prevImage();
    });
    advertisementsWrapper
        .querySelector('._msnlq-glr-rightarrow')
        .addEventListener('click', function () {
        nextImage();
    });
    return advertisementsWrapper;
};
export default rememberMeAdvertisements;
